import React, { useState, useEffect } from 'react';
import MainLayout from '../components/MainLayout';
import { callAPI } from '../utils/apiUtils';
import { apiUrls } from '../utils/apiUrls';
import { HTTP_STATUS } from '../utils/httpStatusCodes';
import { useLocation, useNavigate } from 'react-router-dom';
import AddDeliveryAddressModal from '../components/modals/AddDeliveryAddressModal';
import GuardedNavigationModal from '../components/modals/GuardedNavigationModal';
import useNavigationGuard from '../hooks/useNavigationGuard'
import { getOfflineDeliveryAddresses, updateOfflineOrderAddress, addOfflineDeliveryAddress} from '../utils/offlineDelivery';
import { isOfflineAndroid } from '../utils/androidOfflineCart';
import { getOfflineCustomer} from '../utils/offlineCustomers';




const DeliveryAddress = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentCustomerId, setCurrentCustomerId] = useState(null);
  const [currentOrderId, setCurrentOrderId] = useState(null);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [customerInfo, setCustomerInfo] = useState({
    first_name: '',
    last_name: '',
    email: '',
    mobile: ''
  });
  const { showModal, confirmNavigation, cancelNavigation, guardedNavigate } = useNavigationGuard(true);

  useEffect(() => {
    const offline =  isOfflineAndroid();
    const orderId = offline
    ? (
        location.state?.local_order_id ||
        localStorage.getItem('current_order_id')
      )
    : (
        location.state?.order_id ||
        localStorage.getItem('current_order_id')
      );
    const customerId = offline
      ? (
          location.state?.local_customer_id ||
          localStorage.getItem(
            'current_customer_id'
          )
        )
      : (
          location.state?.customer_id ||
          localStorage.getItem(
            'current_customer_id'
          )
        );
      console.log(
        '[DELIVERY_ADDRESS] orderId:',
        orderId
      );

      console.log(
        '[DELIVERY_ADDRESS] customerId:',
        customerId
      );
    setCurrentOrderId(orderId);
    setCurrentCustomerId(customerId);

    fetchCustomerDetails(customerId);
    fetchAddresses(customerId);
  }, []);

  const fetchCustomerDetails = async (customerId) => {
    try {
        if (isOfflineAndroid()) {

             console.log(
              '[OFFLINE_CUSTOMER] Loading customer from Room -',
              customerId
            );

            const result = await getOfflineCustomer(customerId);

            console.log(
              '[OFFLINE_CUSTOMER] Room response:',
              JSON.stringify(result, null, 2)
            );

            if (!result?.success) {
              console.error(
                '[OFFLINE_CUSTOMER] Failed:',
                result?.error
              );

              return;
            }

            
            const customer = result?.data;

            if (!customer) {
              console.warn(
                '[OFFLINE_CUSTOMER] Customer not found:',
                customerId
              );

              return;
            }

            console.log(
              '[OFFLINE_CUSTOMER] Selected customer:',
              JSON.stringify(customer, null, 2)
            );

            setCustomerInfo({
              first_name: customer.firstName || '',
              last_name: customer.lastName || '',
              email: customer.email || '',
              mobile: customer.contactNumber || ''
            });

            return;
        }

      const res = await callAPI(apiUrls.CUSTOMER_DETAILS,{ current_customer_id: customerId }, 'GET');
      if (res.status === HTTP_STATUS.OK) {
        const customer = res.data.data?.customer;
        setCustomerInfo({
          first_name: customer.firstName,
          last_name: customer.lastName,
          email: customer.email,
          mobile: customer.contactNumber
        });
      }
    } catch (error) {

      console.error(
        '[CUSTOMER_DETAILS] Failed to load customer:',
        error
      );
    }
  };

  const fetchAddresses = async (customerId) => {
    try { 
       if (isOfflineAndroid()) {

          console.log(
            '[OFFLINE_DELIVERY_ADDRESS] Loading from Room',
            customerId
          );

          const result =
            await getOfflineDeliveryAddresses({
              localCustomerId: customerId
            });

            
          console.log(
            '[OFFLINE_DELIVERY_ADDRESS] Room response:',
             JSON.stringify(
              result,
              null,
              2
            ) 
          );

          if (!result?.success) {

            console.error(
              '[OFFLINE_DELIVERY_ADDRESS] Failed:',
              result?.error
            );

            setAddresses([]);

            return;
          }

          const deliveryAddresses =
            result?.data || [];

          console.log(
            '[OFFLINE_DELIVERY_ADDRESS] Addresses:',
            deliveryAddresses
          );

          setAddresses(
            deliveryAddresses
          );

          if (deliveryAddresses.length > 0) {
              const firstAddress = deliveryAddresses[0];
              const localAddressId =   firstAddress.localAddressId;
              console.log(
                '[OFFLINE_DELIVERY_ADDRESS] Selected localAddressId:',
                localAddressId
              );

            setSelectedAddressId(localAddressId);
            
          }

          return;
      }

        const res = await callAPI(apiUrls.CUSTOMER_DELIVERY_ADDRESS, { current_customer_id: customerId } , 'GET');
        if (res.status === HTTP_STATUS.OK) {
          const deliveryAddresses = res.data.data?.delivery_address || [];
          setAddresses(deliveryAddresses);
          if (deliveryAddresses.length > 0) {
            setSelectedAddressId(deliveryAddresses[0].id);
          }
        }
      } catch (error) {

          console.error(
            '[DELIVERY_ADDRESS] Failed to load addresses:',
            error
          );

          setAddresses([]);
      }
  };


  const handleAddAddressSubmit = async (formData) => {
     if (isOfflineAndroid()) {

      console.log(
        '[OFFLINE_DELIVERY_ADDRESS] Creating address in Room',
        {
          localCustomerId: currentCustomerId,
          formData
        }
      );

      const payload = {
        localCustomerId: currentCustomerId,

        name: formData.name,
        mobile: formData.mobile,

        address_line_1: formData.address_line_1,
        address_line_2: formData.address_line_2 || null,

        city: formData.city,
        state: formData.state,
        country: formData.country,
        postal_code: formData.postal_code,

        latitude: formData.latitude
          ? String(formData.latitude)
          : null,

        longitude: formData.longitude
          ? String(formData.longitude)
          : null,

        fullAddress:
          formData.full_address ||
          [
            formData.address_line_1,
            formData.address_line_2,
            formData.city,
            formData.state,
            formData.postal_code,
            formData.country
          ]
            .filter(Boolean)
            .join(', ')
      };

      const response = await addOfflineDeliveryAddress({
        localCustomerId: currentCustomerId,
        addressData: payload
      });

      console.log(
        '[OFFLINE_DELIVERY_ADDRESS] Create response:',
        JSON.stringify(response, null, 2)
      );

      if (!response?.success) {
        return {
          success: false,
          errors: {
            general: [
              response?.error ||
              'Failed to save delivery address offline.'
            ]
          }
        };
      }

      // Reload addresses from Room so the new address appears.
      await fetchAddresses(currentCustomerId);

      return {
        success: true
      };
    }
    formData.selected_customer_id = currentCustomerId;
    try {
      const response = await callAPI(apiUrls.SAVE_DELIVERY_ADDRESS, {}, 'POST', formData, {});
      if (response.status === HTTP_STATUS.OK) {
        if (response.data?.errors) {
          return { success: false, errors: response.data.errors };
        } else {
          await fetchAddresses(currentCustomerId);
          return { success: true };
        }
      } else {
        return { success: false, errors: { general: ['Something went wrong. Please try again.'] } };
      }
    } catch (error) {
      if (error.response && error.response.data?.data?.errors) {

        return { success: false, errors: error.response.data.data.errors };
      } else {
        return { success: false, errors: { general: ['Something went wrong. Please try again.'] } };
      }
    }
  };
  
  

  const proceedToPay = async () => {
    if (!selectedAddressId) {
      alert('Please select a delivery address');
      return;
    }
  
    try {

     if (isOfflineAndroid()) {

      console.log(
        '[OFFLINE_ORDER_ADDRESS] Saving address against order',
        {
          localOrderId: currentOrderId,
          localAddressId: selectedAddressId,
          localCustomerId: currentCustomerId
        }
      );

      const response =
        await updateOfflineOrderAddress({
          orderId: currentOrderId,
          localAddressId: selectedAddressId,
          localCustomerId: currentCustomerId
        });

      console.log(
        '[OFFLINE_ORDER_ADDRESS] Response:',
        JSON.stringify(response, null, 2)
      );

      if (!response?.success) {

          console.error(
            '[OFFLINE_ORDER_ADDRESS] Failed:',
            response?.error
          );

          alert(
            response?.error ||
            'Failed to save delivery address'
          );

          return;
        }

        console.log(
          '[OFFLINE_ORDER_ADDRESS] Address saved successfully'
        );

        const navState = {
          customer_id: currentCustomerId,
          order_id: currentOrderId,
          local_customer_id: currentCustomerId,
          local_order_id: currentOrderId,
          local_address_id: selectedAddressId
        };

        navigate(
          '/payment-view?order_id=' + currentOrderId,
          {
            state: navState
          }
        );

        return;
      }

      
      const payload = {
        address_id: selectedAddressId,
        order_id: currentOrderId
      };
  
      const response = await callAPI(
        apiUrls.SET_ORDER_ADDRESS,
        {},
        'POST',
        payload,
        {}
      );
  
      if (response.status === HTTP_STATUS.OK) {
        const navState = {
          customer_id: currentCustomerId,
          order_id: currentOrderId,
        };
  
        navigate('/payment-view?order_id=' + currentOrderId, { state: navState });
      } else {
        alert('Failed to set delivery address');
      }
    } catch (error) {
      console.error('Error setting address:', error);
      alert('Something went wrong. Please try again.');
    }
  };
  
  const customFooterButtons = (
    <>
      <button className="btn iconBtn btnLight" onClick={() => setModalOpen(true)}>
        Add Delivery Address
      </button>
      <button className="btn iconBtn btnPrimary" onClick={proceedToPay}>
        Proceed to Pay
      </button>
    </>
  );

  return (
    <MainLayout  guardedNavigate={guardedNavigate} footerButtons={customFooterButtons}>
      <div className="pageContent transferOptionsPage dflexCol">
        <div className="container">
          <div className="selectCustomerCol dladdress">
            <h4 className="lgTitle text-center pb-3">Select Delivery Address</h4>
            <form className="formStyle pt-2 pt-md-4 mt-md-3">
              <div className="col-12">
                <p className="fw-medium mb-2">
                  {customerInfo.first_name} {customerInfo.last_name}
                </p>
                <p className="pb-3">
                  {customerInfo.email}, {customerInfo.mobile}
                </p>

                {addresses.length === 0 && <p>No delivery addresses found.</p>}

                {addresses.map((address, index) => {

                const addressId = isOfflineAndroid() ? address.localAddressId : address.id;


                  return (
                  <div className="form-check mb-4" key={addressId}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="serviceType"
                      id={`serviceType${index}`}
                      checked={selectedAddressId === addressId}
                      onChange={() => setSelectedAddressId(addressId)}
                    />
                    <label className="form-check-label" htmlFor={`serviceType${index}`}>
                      <span>{address.full_address}</span>
                      {address.distance_from_restaurant_in_kms > 0 && (
                        <span>{parseFloat(address.distance_from_restaurant_in_kms).toFixed(2)} Kms</span>
                      )}
                    </label>
                  </div>
                  );
                })}
              </div>
            </form>
          </div>
        </div>
      </div>

      <AddDeliveryAddressModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onSubmit={handleAddAddressSubmit}
        customerInfo={customerInfo}
      />
            <GuardedNavigationModal 
            isOpen={showModal} 
            onCancel={cancelNavigation} 
            onConfirm={confirmNavigation} 
        />

    </MainLayout>
  );
};

export default DeliveryAddress;
